import DivisionPage from "./DivisionPage";

export default function GoodsTransport() {
  return <DivisionPage slug="goods-transport" />;
}
